// @mui
import { IconButton, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// hooks
import useSettings from '../../../hooks/useSettings';
//
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

type ThemeModeSwitchProps = {
  isOffset?: boolean;
  inPreviewHeader?: boolean;
};

export default function ThemeModeSwitch({ isOffset, inPreviewHeader }: ThemeModeSwitchProps) {
  const theme = useTheme();
  const { themeMode, onToggleMode } = useSettings();

  const isDark = themeMode !== 'light';
  const useWhiteForeground = isOffset === false;

  const themeIconColor = inPreviewHeader
    ? 'inherit'
    : isDark
      ? theme.palette.common.white
      : useWhiteForeground
        ? theme.palette.common.white
        : theme.palette.grey[800];

  return (
    <Tooltip title={isDark ? 'Modo claro' : 'Modo escuro'}>
      <IconButton onClick={onToggleMode} sx={{ color: themeIconColor, mr: 0.5 }}>
        <Iconify
          icon={isDark ? 'solar:sun-bold-duotone' : 'solar:moon-bold-duotone'}
          width={20}
          height={20}
        />
      </IconButton>
    </Tooltip>
  );
}
